import { forwardRef } from "react";
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom";

/**
 * @deprecated Use the TextButton component from the ui-components package to show links instead.
 * Link redirection logic should be handled by the specific application that consumes this component.
 * Buttons in ui-components accept a LinkComponent prop which must be passed by the consuming application.
 */
export const BaseLink = forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => {
  return <RouterLink ref={ref} {...props} />;
});

BaseLink.displayName = "BaseLink";
